import { Col, Row } from 'antd';
import React from 'react';
import loginBalken from '../../../static/img/balken/login_BALKEN.png';
import { Aside, Card, DesktopLogo, MainContent } from './overview/style';

const AuthLayout = (WraperContent) => {
  return function () {
    return (
      <Row style={{ margin: 0 }}>
        {/* Sidebar con logo (solo desktop) */}
        <Col lg={10} md={10} sm={0} xs={0}>
          <Aside>
            <DesktopLogo src={loginBalken} alt="Logo Balken" />
          </Aside>
        </Col>

        {/* Contenido principal */}
        <Col lg={14} md={14} sm={24} xs={24}>
          <MainContent>
            <Card>
              <WraperContent />
            </Card>
          </MainContent>
        </Col>
      </Row>
    );
  };
};

export default AuthLayout;
